import { render } from "./BetaProfileProgressCard.vue?vue&type=template&id=94d4c1f6&scoped=true"
import script from "./BetaProfileProgressCard.vue?vue&type=script&lang=js"
export * from "./BetaProfileProgressCard.vue?vue&type=script&lang=js"

import "./BetaProfileProgressCard.vue?vue&type=style&index=0&id=94d4c1f6&scoped=true&lang=css"
import "./BetaProfileProgressCard.vue?vue&type=style&index=1&id=94d4c1f6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94d4c1f6"]])

export default __exports__